import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step3_1 from "@/assets/integration-steps/tiktok/step_3_1.png";
import step3_2 from "@/assets/integration-steps/tiktok/step_3_2.png";

interface Props {
  stepLabel?: string;
}

const TikTokIntegrationStep3 = ({ stepLabel }: Props) => {
  return (
    <div className="channels-integration-step tiktok-step-3">
      <div className="step-label-row">
        {stepLabel && <OpticksNumberCircle number={stepLabel} />}
        <h6>Assign the audience to your TikTok campaigns</h6>
      </div>
      <div className="step-label-row">
        <p>
          In TikTok Ads, audiences can only be excluded at Ad Group level. To
          exclude the Opticks Negative Audience, go to edit the Ad Group, then
          scroll until the "Audience" section, and add the Opticks Negative
          Audience.
        </p>
      </div>
      <p>
        <b>Note:</b> the audience might not appear here until it has received
        some amount of invalid traffic, due to limitations imposed by TikTok.
      </p>
      <img src={step3_1} alt="Screenshot of step 3.1 TikTok Integration" />
      <img src={step3_2} alt="Screenshot of step 3.2 TikTok Integration" />
    </div>
  );
};

export default TikTokIntegrationStep3;
